/***
 *
 *   ONGOING DUE DILIGENCE
 *   Minimal reviewer surface listing the account's Enhanced Due Diligence (EDD)
 *   cases and their current state (FR-014). Reads from GET /api/edd/cases.
 *
 **********/

import React, { Fragment, useEffect, useState } from "react";
import {
  Animate,
  Card,
  Message,
  Table,
  TitleRow,
  useAPI,
} from "components/lib";

// Human-readable labels for the edd_case states (data-model §edd_case.state).
const STATE_LABELS = {
  awaiting_customer: "Awaiting customer",
  awaiting_assessment: "Awaiting assessment",
  awaiting_approval: "Awaiting approval",
  closed_approved: "Closed - approved",
  closed_declined: "Closed - declined",
};

function ratingLabel(rating) {
  if (!rating) return "-";
  return rating.charAt(0).toUpperCase() + rating.slice(1);
}

export function OngoingDueDiligenceView() {
  const cases = useAPI("/api/edd/cases");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const list = Array.isArray(cases?.data) ? cases.data : [];

    setRows(
      list.map((c) => {
        const verification = c.verification || {};
        const name = [verification.first_name, verification.last_name]
          .filter(Boolean)
          .join(" ");
        const customer =
          name || verification.email || verification.name || "Unknown customer";

        return {
          id: c.id,
          customer,
          email: verification.email || "",
          state: STATE_LABELS[c.state] || c.state || "-",
          trigger_rating: ratingLabel(c.trigger_rating),
          current_rating: ratingLabel(c.rating),
          updated_at: c.updated_at || c.created_at || "",
          verification_id: c.verification_id || verification.id || null,
        };
      })
    );
  }, [cases.data]);

  return (
    <Fragment>
      <Animate>
        <TitleRow title="Ongoing Due Diligence" />

        <Message
          type="info"
          title="Enhanced Due Diligence cases"
          text="Customers automatically engaged in EDD and the current state of each case. Open a case to complete the internal EDD assessment and record the officer decision."
        />

        <Card>
          <Table
            search
            data={rows}
            loading={cases.loading}
            show={[
              "customer",
              "email",
              "state",
              "trigger_rating",
              "current_rating",
              "updated_at",
            ]}
            badge={{
              col: "state",
              color: "blue",
              condition: [
                { value: "Awaiting customer", color: "orange" },
                { value: "Awaiting assessment", color: "blue" },
                { value: "Awaiting approval", color: "purple" },
                { value: "Closed - approved", color: "green" },
                { value: "Closed - declined", color: "red" },
              ],
            }}
            actions={{ view: { url: "/verification/edd", col: "id" } }}
          />
        </Card>
      </Animate>
    </Fragment>
  );
}
